import { initializeLocaleSession } from './features/locale/session'
import { syncSessionAcrossTabs } from './features/auth/session-navigation'
import { initApiClient } from './api/client'
import { initLogRocket } from './lib/logrocket'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider, createRouter } from '@tanstack/react-router'
import { RouteFailure } from '@/components/layout/RouteFailure'
import { RouteNotFound } from '@/components/layout/RouteNotFound'
import { Providers } from './app/providers'
import './index.css'

import { routeTree } from './routeTree.gen'
import { isGuestPublicPath, isMobileBrowser } from './components/layout/mobile-access'
import { MobileAccessNotice } from './components/layout/MobileAccessNotice'
import { NamespaceBoundary } from './lib/i18n/NamespaceBoundary'

const mobileNotice = isMobileBrowser() && !isGuestPublicPath(window.location.pathname)

initApiClient()
syncSessionAcrossTabs()
// LogRocket goes after the API client so its network instrumentation can wrap
// the same fetch the SDK uses. Identify happens automatically via a Zustand
// subscription — see lib/logrocket.ts.
if (!mobileNotice) void initLogRocket()

const router = createRouter({ routeTree, defaultErrorComponent: RouteFailure, defaultNotFoundComponent: RouteNotFound })

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}

async function bootstrap() {
  await initializeLocaleSession()
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      {mobileNotice ? <NamespaceBoundary namespace="shell"><MobileAccessNotice /></NamespaceBoundary> : <Providers>
        <RouterProvider router={router} />
      </Providers>}
    </StrictMode>,
  )
}
void bootstrap()
